import { WarrantyItemForMissing, WarrantyItemForDamaged, WarrantyItemType, CreateOrderWarrantyRequest } from "../types";

type NavContextOut = (m: string, t: string, p: string) => void;

export const usePartFormatter: () => {
    getDataByNavContext: (navContext: string, out: NavContextOut) => void;
    getNavContextByData: (m: string, t: string, p: string) => string;
    setNavContextByData: (m: string, t: string, p: string) => string;
    formatPartForOrderWarranty: (itemList: WarrantyItemForMissing[] | WarrantyItemForDamaged[], warrantyOrderType: WarrantyItemType, brand: string, customerCode: string, formFields: {
        deliveryAddress: string;
        invoiceAddress: string;
        partialShipment: boolean;
        note: string;
        deliveryDate: string;
        noteItems: {};
        hasAgreement: boolean;
        cgvAgreement:boolean,
        ponReference: string;
    }) => CreateOrderWarrantyRequest
} = () => {

    /**
     * getDataByNavContext
     * @param out function that return {machine, tableCode, position}
     * @returns 
     */
    const getDataByNavContext = (navContext: string, out: NavContextOut): void => {
        if (navContext === "" || navContext === undefined || navContext === null) return out("", "", "");

        const stringList = navContext?.split("/");

        out(stringList[0].trim(), stringList[1] ? stringList[1].trim() : "", stringList[2] ? stringList[2].trim() : "");
    }

    /**
     * formatPartForOrderWarranty
     * @returns {CreateOrderWarrantyRequest} Tutte le info per creare un Ordine di garanzia
     */
    const formatPartForOrderWarranty = (itemList: WarrantyItemForMissing[] | WarrantyItemForDamaged[], warrantyOrderType: WarrantyItemType, brand: string, customerCode: string, formFields: {
        deliveryAddress: string;
        invoiceAddress: string;
        partialShipment: boolean;
        note: string;
        deliveryDate: string;
        noteItems: {};
        hasAgreement: boolean;
        cgvAgreement:boolean;
        ponReference: string;
    }): CreateOrderWarrantyRequest => {
        var machine: string;
        var tableCode: string;
        var pos: string;

        const newItemList = itemList.map((item) => {
            if (item.navContext)
                getDataByNavContext(
                    item.navContext,
                    (m, t, p) => {
                        machine = m;
                        tableCode = t;
                        pos = p;
                    }
                );

            return {
                ...item,
                machineSN: machine,
                table: tableCode,
                position: pos,
            };
        });

        const warrantyRequest: CreateOrderWarrantyRequest = {
            sellingCompanyCode: brand,
            customerReference: formFields.ponReference,
            shipTo: formFields.deliveryAddress,
            note: formFields.note,
            deliveryDate: formFields.deliveryDate,
            partialShipmentFlag: Boolean(formFields.partialShipment),
            warrantyOrderType: warrantyOrderType,
            items: newItemList,
        };

        return warrantyRequest;
    }


    const getNavContextByData = (m: string, t: string, p: string): string => {
        const navContext: string = `${m !== "" ? m : "-"} / ${t !== "" ? t : "-"} / ${p !== "" ? p : "-"}`;

        return navContext.trim();
    }

    const setNavContextByData = (m: string, t: string, p: string): string => {
        if (m === "" && t === "" && (p === "" || p==="0")) return "";

        const navContext: string = `${m !== "" ? m : ""} / ${t !== "" ? t : ""} / ${p !== "" ? p : ""}`;

        return navContext.trim();
    }


    return { getDataByNavContext, getNavContextByData, setNavContextByData, formatPartForOrderWarranty };
}